<template>
  <span
    class="skeleton-loader"
    :class="{'-rounded': rounded}"
    :style="{ height, width }"
  />
</template>

<script>
export default {
  name: 'SkeletonLoader',
  props: {
    height: {
      default: '1em',
      type: String,
    },

    width: {
      default: '100%',
      type: String,
    },

    rounded: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.skeleton-loader {
  @apply inline-block;
  @apply relative;
  @apply overflow-hidden;
  vertical-align: middle;
  background-color: #DDDBDD;

  &.-rounded {
    border-radius: 100%;
  }

  &:after {
    @apply absolute;
    @apply top-0;
    @apply right-0;
    @apply bottom-0;
    @apply left-0;
    transform: translateX(-100%);
    background-image: linear-gradient( 90deg, rgba(#fff, 0) 0, rgba(#fff, 0.2) 20%, rgba(#fff, 0.5) 60%, rgba(#fff, 0));
    animation: skeleton-loader 3s infinite;
    content: '';
  }
}
</style>
